import React from 'react';
import styled from 'styled-components';
import NewConversationInput from './NewConversationInput';
import { startCase } from 'lodash';

interface Props {
  category?: string;
  afterSend: () => void;
  initialComposition: {
    category?: string;
    subject?: string;
    message?: string;
  };
}

const ComposeNewMessage = ({ category, afterSend, initialComposition }: Props) => {
  return (
    <Main>
      <Subject>
        Kindbody {startCase(category)} Team &bull; {'New Message'}
      </Subject>
      <NewConversationInput
        subject={initialComposition.subject || ''}
        message={initialComposition.message || ''}
        category={category}
        afterSend={afterSend}
      />
    </Main>
  );
};

export default ComposeNewMessage;

const Main = styled.div`
  background-color: ${({ theme }) => theme.colors.beige};
  padding-bottom: 0.5em;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: fit-content;
`;

const Subject = styled.div`
  ${({ theme }) => theme.fonts.FoundersGrotesk};
  font-weight: bold;
  text-align: center;
  padding: 1em 0;
  border-bottom: 2px solid rgb(199, 183, 167);
`;
